<template>
  <!-- 学员备注详情 -->
  <div>
    <!-- <el-table
      :data="list"
      style="width: 100%"
      border
      stripe
      :header-cell-style="{ background: '#f5f7fa' }"
      max-height="500"
    >
      <el-table-column
        v-if="!order"
        :prop="isCapital ? 'CreateTime' : 'createTime'"
        label="日期"
        width="180"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        v-if="!order"
        :prop="isCapital ? 'AdminName' : 'adminName'"
        label="操作人"
        width="100"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span
            :class="{
              gray:
                scope.row.AdminName === '无' ||
                scope.row.AdminName === '暂不知' ||
                scope.row.adminName === '无' ||
                scope.row.adminName === '暂不知',
            }"
            v-if="scope.row.AdminId || scope.row.adminId"
          >
            {{ isCapital ? scope.row.AdminName : scope.row.adminName }}
          </span>
          <span class="gray" v-else>未设置</span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="order"
        label="序号"
        width="100"
        :show-overflow-tooltip="true"
      >
        <template scope="scope">
          <span>备{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :prop="isCapital ? 'Contents' : 'contents'"
        label="内容"
      >
      </el-table-column>
    </el-table> -->
    <div class="scroll">
      <div class="process_content">
        <div class="steps" v-for="(item, index) in list" :key="index">
          <div class="left_steps_time">
            <div class="steps_time" v-if="item.CreateTime || item.createTime">
              <p>{{ isCapital ? timeFormatNew(item.CreateTime, 'yyyy-MM-dd') : timeFormatNew(item.createTime,
                'yyyy-MM-dd') }}
              </p>
              <p>{{ isCapital ? timeFormatNew(item.CreateTime, 'hh:mm:ss') : timeFormatNew(item.createTime, 'hh:mm:ss') }}
              </p>
            </div>
            <div class="icon_clock">
              <i class="el-icon-time"></i>
            </div>
          </div>
          <div class="steps_content">
            <div class="nextTime"></div>
            <div class="flex_text">
              <div>操作老师：</div>
              <div class="flex_div" v-if="item.AdminName || item.adminName" :class="{
                gray:
                  item.AdminName === '无' ||
                  item.AdminName === '暂不知' ||
                  item.adminName === '无' ||
                  item.adminName === '暂不知',
              }">
                {{ isCapital ? item.AdminName : item.adminName }}
              </div>
              <span class="gray" v-else>未设置</span>
            </div>
            <div class="flex_text"></div>
            <div class="flex_text">
              <div>备注内容：</div>
              <div v-if="item.contents || item.Contents" class="flex_div">{{ isCapital ? item.Contents : item.contents }}
              </div>
              <div v-else class="gray">暂无</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { timeFormatNew } from "common/utils";
export default {
  name: "RemarkList",
  components: {},
  props: {
    list: {
      type: Array,
    },
    isCapital: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
  },
  created() {
  },
  data() {
    return {
    };
  },
  created() { },
  methods: {
    timeFormatNew
  },
};
</script>
<style scoped>
.fail {
  margin-top: 150px;
  text-align: center;
  color: #959595;
}

.el-icon-time {
  font-size: 22px;
  color: #999;
}

.scroll {
  height: 400px;
  /* height: auto; */
  overflow-y: scroll;
}

.process_content {
  position: relative;
  padding: 25px 60px 0 126px;
  background-color: #fff;
}

.process_content::before {
  content: "";
  display: block;
  width: 2px;
  height: 90%;
  background-color: #ebebeb;
  position: absolute;
  left: 102px;
  top: 45px;
}

.steps {
  padding-bottom: 30px;
}

.left_steps_time {
  position: relative;
  left: -136px;
  top: -4px;
  font-size: 14px;
}

.steps_time {
  display: inline-block;
  text-align: right;
  position: absolute;
  left: 10px;
  top: 1px;
  color: #607080;
}

.icon_clock {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 104px;
  margin-left: -3px;
  background-color: #fff;
}

.steps_content {
  position: relative;
  top: -6px;
  font-size: 14px;
}

.steps_text p {
  line-height: 28px;
  font-size: 16px;
}

.font_status {
  font-size: 16px;
}

.green_status {
  color: #67c23a;
}

.gray_status {
  color: #999;
}

.flex_text {
  width: 100%;
  margin-top: 3px;
  text-align: left;
  display: flex;
  flex-direction: row;
}

.flex_text div:first-child {
  color: #999;
}

.flex_div {
  flex: 1;
  color: #303133;
}

.nextTime {
  position: absolute;
  right: 0;
  color: #f56c6c;
}

.pointer {
  cursor: pointer;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #fff !important;
}

.table-column-img {
  width: 80px;
  height: 100%;
  border: 1px solid #dcdfe6;
}

#studenttrackrecord>>>.el-image__error,
#studenttrackrecord>>>.el-image__inner,
#studenttrackrecord>>>.el-image__placeholder {
  width: 80px;
  height: 80px;
}

.gray {
  color: gray;
}
</style>